// extracted by mini-css-extract-plugin
export default {"completed":"complete_completed__M62U7","contentWrapper":"complete_contentWrapper__cX5QB","buttonWrapper":"complete_buttonWrapper__wYrgJ","link":"complete_link__CiPuq"};